import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from '@redux';
import crudActions from '@redux/crudActions';
import { Button } from 'antd';
import useToggleModal from 'hooks/useToogleModal';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DynamicObjectType } from 'types/commons';
import { DelModalStyles } from '../styles';
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';

interface DeleteModalTypes {
  title: string;
  modal: string;
  customDesc?: string;
  isBack?: boolean;
  record?: DynamicObjectType;
}

export interface RefDeleteModalProps {
  open: () => void;
}

const DeleteModal = (
  { title, modal, customDesc, isBack = true, record },
  ref,
) => {
  const { t } = useTranslation();
  const productCurr = useSelector(
    (state) => state[modal].currentData,
  ) as DynamicObjectType;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loadingDelete, setLoadingDelete] = useState(false);
  const { visible, toggleModal } = useToggleModal();

  const handleDelete = () => {
    setLoadingDelete(true);
    dispatch(
      crudActions[modal].del({
         data: { id: record?.id || productCurr?.id },
         options: {
            isShowSuccessNoti: true,
            isReloadGetAll: true,
         }
      }),
    ).then(({payload}) => {
      setLoadingDelete(false);
      toggleModal();
      if (!payload?.error) {
         if (isBack) {
            navigate(-1);
         }
      }
    });
  };

  const onCancel = () => {
    toggleModal();
    // form.resetFields();
  };

  useImperativeHandle(
    ref,
    () => ({
      open: () => {
        toggleModal();
        // form.setFieldsValue(data);
      },
    }),
    [], // eslint-disable-line
  );

  return (
    <DelModalStyles closeIcon={false} footer={null} open={visible}>
      <div className="delModal-wrap">
        <FontAwesomeIcon icon={faCircleExclamation} className="delModal-icon" />
        <div>
          <div className=" fw-600 title-gray-color">
            {t('common.modal.deleteTitle', { title: title })}
          </div>
          <div className="text-sm fw-400 title-gray-color mt-2.5">
            {customDesc || t('common.modal.deleteContent', { content: title })}
          </div>
        </div>
      </div>
      <div className="d-flex flex-end">
        <Button onClick={onCancel} className="btn-light mr-[5px] btn-h-32">
          {t('common.modal.cancel')}
        </Button>
        <Button
          loading={loadingDelete}
          onClick={handleDelete}
          type="primary"
          className="ml-[5px] btn-h-32"
        >
          {t('common.modal.ok')}
        </Button>
      </div>
    </DelModalStyles>
  );
};

export default forwardRef<RefDeleteModalProps, DeleteModalTypes>(DeleteModal);
